import { sendSubscriptionToPushServer } from 'src/store/api/notificationsApi';
import logger from 'src/utils/logger';

const isPushNotificationSupported = () => {
    return 'serviceWorker' in navigator && 'PushManager' in window;
};

const askUserPermission = async () => {
    return await Notification.requestPermission();
};

const getConsentGranted = () => {
    return Notification.permission === 'granted';
};

const getUserSubscription = async () => {
    try {
        // 1. Önce Service Worker desteği var mı kontrol et
        if (!('serviceWorker' in navigator) || !navigator.serviceWorker) {
            logger.warn("Push Manager desteklenmiyor: Service Worker bulunamadı.");
            return null;
        }

        // 2. Ready durumunu bekle
        const serviceWorker = await navigator.serviceWorker.ready;

        // 3. PushManager var mı kontrol et (Bazı tarayıcılarda SW var ama Push yok)
        if (!serviceWorker.pushManager) {
            logger.warn("Push Manager bu tarayıcıda mevcut değil.");
            return null;
        }

        return await serviceWorker.pushManager.getSubscription();
    } catch (error) {
        logger.error("Abonelik alınırken hata oluştu:", error);
        return null;
    }
};

const createNotificationSubscription = async (pushServerPublicKey) => {
    // 1. Önce tarayıcı desteğini ve nesnenin varlığını kontrol et
    if (!('serviceWorker' in navigator) || !navigator.serviceWorker) {
        logger.warn("Push aboneliği oluşturulamaz: Service Worker desteği yok.");
        return null;
    }

    try {
        // 2. Service Worker'ın hazır olmasını bekle
        const serviceWorker = await navigator.serviceWorker.ready;

        // 3. PushManager kontrolü (Özellikle iOS ve eski tarayıcılar için kritik)
        if (!serviceWorker.pushManager) {
            logger.error("Bu tarayıcı Push Manager özelliğini desteklemiyor.");
            return null;
        }

        // 4. Aboneliği oluştur
        return await serviceWorker.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: pushServerPublicKey
        });
    } catch (error) {
        // Kullanıcı "İzin Ver" yerine "Reddet" derse hata buraya düşer
        logger.error("Abonelik oluşturulurken hata:", error);
        return null;
    }
};

export const initNotifications = async pushServerPublicKey => {
    if (isPushNotificationSupported()) {
        if (!getConsentGranted()) await askUserPermission();
        if (getConsentGranted()) {
            if (!(await getUserSubscription())) {
                await sendSubscriptionToPushServer(await createNotificationSubscription(pushServerPublicKey));
            }
        }
    }
};
